import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Container, Row, Col } from "reactstrap";
import Button from "reactstrap/lib/Button";
import S2 from "./svgs/s2";
import S5 from "./svgs/s5";
import S8 from "./svgs/s8";
import S1 from "./svgs/s1";
import S3 from "./svgs/s3";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  const content = [
    {
      title: "The Next Phase of Saudi Arabia’s Fintech Revolution",
      description:
        "Navigating regulatory landscapes, fostering collaboration between traditional banks and fintech firms, and driving seamless digital adoption. ",
      image: <S2 />,
    },
    {
      title: "Open Banking and Vision 2030",
      description:
        "With Saudi Arabia's regulatory push towards open banking aligning with Vision 2030’s digital transformation and financial sector development goals. This theme explores how Open Banking will enhance competition, foster innovation, and drive financial inclusion in the Kingdom.",
      image: <S3 />,
    },
    {
      title: "The Evolution of Digital-First Banking",
      description:
        "Customer expectations are evolving, and digital-first banking is no longer optional—it’s essential. From AI-powered chatbots and hyper-personalized financial products to next-generation neobanks and super apps, this session will highlight how financial institutions are redefining customer engagement through seamless, AI-driven digital banking experiences.",
      image: <S1 />,
    },
  ];
  return (
    <>
      <div
        style={{
          background: "transparent",
        }}
        className="section"
        data-parallax={true}
        ref={pageHeader}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <h1
                className=" text-700 pb-0 text-white mt-0 text-uppercase"
                style={{ fontSize: size ? "2.5rem" : "1.5rem" }}
              >
                <b>
                  Empowering the Fintech Ecosystem:
                  <br /> From Disruption to Collaboration
                </b>
              </h1>
            </Col>
            <Col lg={6} md={6} sm={12} className="">
              <h5
                className="text-600 text-white text-justify"
                style={{
                  lineHeight: "30px",
                  color: "#010011",
                  textTransform: "none",
                }}
              >
                <br />
                <br />
                As the Kingdom of Saudi Arabia rapidly ascends as a global leader in digital
                financeSaudi Arabia is making a bold push to redefine its financial ecosystem, as
                seen in the launch of the Saudi Central Bank’s (SAMA) regulatory sandbox, the rise
                of digital banking licenses, and increased venture capital investments fueling
                fintech growth. Finnovex Saudi Arabia 2025 returns as the premier gathering of
                visionaries, innovators, and decision-makers shaping the future of financial
                services. Against the backdrop of Vision 2030’s ambitious financial sector
                development goals, this year's summit will delve deep into the transformative impact
                of fintech, artificial intelligence, cybersecurity, open banking, and digital assets
                on the evolving financial landscape.
                <br />
                <br />
                The 30th Edition of Finnovex Saudi Arabia 2025, scheduled for{" "}
                <b>September 2-3 in Riyadh</b>, will bring together top-tier financial leaders,
                innovators, and policymakers to explore how the Kingdom can harness disruption,
                collaboration, and innovation to build a dynamic, inclusive, and sustainable fintech
                ecosystem.
                <br />
                <br />
                <Button className="px-3 py-2  my-2 rounded-0" color="primary" href="/about">
                  <p className="m-0 text-700" style={{ color: "#fff" }}>
                    Know More
                  </p>
                </Button>
              </h5>
            </Col>
            <Col lg={6} className="mt-5 pr-0">
              <div className="container-fluid row pr-0">
                {content.map((s, index) => (
                  <Col className="text-center  p-2 px-0" lg={12} xs={12}>
                    <ScrollAnimation
                      animateIn={"fadeInUp"}
                      animateOnce={true}
                      duration={0.5 + index / 8}
                    >
                      <div className="pt-4 px-2 stat-div" style={{ minHeight: 300 }}>
                        {s.image}

                        <h3
                          style={{
                            color: "#fff",
                            fontSize: size ? "18px" : "14px",
                          }}
                          className="text-700 mt-4"
                        >
                          {s.title}
                        </h3>
                        <h3
                          style={{
                            color: "#fff",
                            fontSize: size ? "16px" : "12px",
                          }}
                          className="text-600 mt-0"
                        >
                          {s.description}
                        </h3>
                      </div>
                    </ScrollAnimation>
                  </Col>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default TextGrid;
